/* Two-state cart drawer recommendations (tango-cart-draw-project, 2026-07).
   The drawer body re-renders via the Section Rendering API on every cart
   change, so these elements reconnect (and state recomputes) each time. */

class CartRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.fetchUrl) {
      this.fetchRecommendations();
    } else {
      this.initSlider();
    }
  }

  fetchRecommendations() {
    const target = this.querySelector('[data-recommendations]');
    if (!target) return;
    fetch(this.dataset.fetchUrl)
      .then(response => response.text())
      .then(text => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fetched = doc.querySelector(
          '.cart-recommendations--fbw [data-recommendations]'
        );
        if (fetched && fetched.children.length > 0) {
          target.innerHTML = fetched.innerHTML;
          this.classList.remove('hidden');
        } else if (target.children.length === 0) {
          this.classList.add('hidden');
        }
        this.initSlider();
      })
      .catch(() => this.initSlider());
  }

  initSlider() {
    if (typeof Swiper === 'undefined') return;
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl || this.slider) return;
    this.slider = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      navigation: {
        prevEl: this.querySelector('[data-rec-prev]'),
        nextEl: this.querySelector('[data-rec-next]')
      }
    });
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}

class CartPairCard extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('[data-pair-toggle]');
    this.sizes = this.querySelector('[data-pair-sizes]');
    this.errorEl = this.querySelector('[data-pair-error]');

    this.toggleBtn?.addEventListener('click', () => this.toggleSizes());

    this.querySelectorAll('[data-pair-variant]').forEach(btn =>
      btn.addEventListener('click', () => this.addVariant(btn))
    );
  }

  toggleSizes() {
    const open = this.sizes.hasAttribute('hidden');
    this.sizes.toggleAttribute('hidden', !open);
    this.toggleBtn.setAttribute('aria-expanded', open);
    this.classList.toggle('is-open', open);
  }

  async addVariant(btn) {
    if (btn.disabled || this.classList.contains('is-requesting')) return;
    this.classList.add('is-requesting');
    this.errorEl.setAttribute('hidden', '');

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', btn.dataset.pairVariant);
      formData.append('quantity', 1);
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender()?.map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();
      if (!response.ok) throw new Error(data.description);

      cartDrawer.renderContents(data, true);
    } catch (error) {
      this.classList.remove('is-requesting');
      this.errorEl.textContent = error.message;
      this.errorEl.removeAttribute('hidden');
    }
  }
}

if (!customElements.get('cart-pair-card')) {
  customElements.define('cart-pair-card', CartPairCard);
}
